export class Item {
    id: string;
    navigate: any;
}

